export default {
  namespaced: true,
  state: {
    fileList: [],
    isShowContainer: false,
    reload: false
  },
  mutations: {
    setFileList(state, file) {
      state.fileList = file
    },
    setReload(state, status) {
      state.reload = status
    },
    setShowContainer(state, status) {
      state.isShowContainer = status
    }
  }
}
